// components/ArtworkCard.jsx
import React from "react";
import classes from "./artworkCard.module.css";
import { useNavigate } from "react-router-dom";

const ArtworkCard = ({ artwork }) => {
  const { title, artist, price, currency, rating, image } = artwork;
  const navigate = useNavigate();

  // Format rating with appropriate number of filled stars
  const renderRating = () => {
    return (
      <div className={classes.rating}>
        {[...Array(5)].map((_, index) => (
          <span
            key={index}
            className={`${classes.star} ${
              index < Math.floor(rating) ? classes.filled : ""
            }`}
          >
            ★
          </span>
        ))}
        <span className={classes.ratingValue}>({rating.toFixed(1)})</span>
      </div>
    );
  };

  const handleOnBuyClick = () => {
    navigate("/buy-art/Spicin/231");
  };
  return (
    <div className={classes.artworkCard}>
      <div className={classes.imageContainer}>
        <img
          src={image || "/api/placeholder/250/300"}
          alt={title}
          className={classes.artworkImage}
        />
      </div>
      <div className={classes.artworkInfo}>
        <h3 className={classes.artworkTitle}>{title}</h3>
        <div className={classes.artistInfo}>
          <span>By {artist}</span>
          {renderRating()}
        </div>
        <div className={classes.priceContainer}>
          <span className={classes.price}>
            {currency} {price}
          </span>
          <button className={classes.buyNowBtn} onClick={handleOnBuyClick}>
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 11l3 3L21 5"></path>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
            Buy Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArtworkCard;
